/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Activity,
  ActivityRequest,
  Contact,
  ContactRequest,
  CrmContactsDuplicatesListParams,
  CrmContactsExportRetrieve200,
  CrmContactsListParams,
  CrmFollowUpSettingsListParams,
  CrmLeadsListParams,
  CrmReferralProgramListParams,
  CrmReferralsListParams,
  Duplicate,
  FollowUpSettings,
  FollowUpSettingsRequest,
  Lead,
  LeadPipeline,
  LeadRequest,
  Member,
  MergeRequest,
  MoveRequest,
  NewClientRequest,
  PaginatedContactList,
  PaginatedFollowUpSettingsList,
  PaginatedLeadList,
  PaginatedReferralList,
  PaginatedReferralProgramList,
  PatchedContactRequest,
  PatchedFollowUpSettingsRequest,
  PatchedLeadRequest,
  PatchedReferralProgramRequest,
  Referral,
  ReferralCode,
  ReferralProgram,
  ReferralProgramRequest,
  StageChange
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type crmContactsListResponse200 = {
  data: PaginatedContactList
  status: 200
}
    
export type crmContactsListResponseSuccess = (crmContactsListResponse200) & {
  headers: Headers;
};
;

export type crmContactsListResponse = (crmContactsListResponseSuccess)

export const getCrmContactsListUrl = (params?: CrmContactsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/contacts/?${stringifiedParams}` : `/api/v1/crm/contacts/`
}

export const crmContactsList = async (params?: CrmContactsListParams, options?: RequestInit): Promise<crmContactsListResponse> => {
  
  return apiFetch<crmContactsListResponse>(getCrmContactsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmContactsListQueryKey = (params?: CrmContactsListParams,) => {
    return [
    `/api/v1/crm/contacts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmContactsListQueryOptions = <TData = Awaited<ReturnType<typeof crmContactsList>>, TError = unknown>(params?: CrmContactsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmContactsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmContactsList>>> = ({ signal }) => crmContactsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmContactsListQueryResult = NonNullable<Awaited<ReturnType<typeof crmContactsList>>>
export type CrmContactsListQueryError = unknown


export function useCrmContactsList<TData = Awaited<ReturnType<typeof crmContactsList>>, TError = unknown>(
 params: undefined |  CrmContactsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsList>>,
          TError,
          Awaited<ReturnType<typeof crmContactsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsList<TData = Awaited<ReturnType<typeof crmContactsList>>, TError = unknown>(
 params?: CrmContactsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsList>>,
          TError,
          Awaited<ReturnType<typeof crmContactsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsList<TData = Awaited<ReturnType<typeof crmContactsList>>, TError = unknown>(
 params?: CrmContactsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmContactsList<TData = Awaited<ReturnType<typeof crmContactsList>>, TError = unknown>(
 params?: CrmContactsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmContactsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmContactsCreateResponse201 = {
  data: Contact
  status: 201
}
    
export type crmContactsCreateResponseSuccess = (crmContactsCreateResponse201) & {
  headers: Headers;
};
;

export type crmContactsCreateResponse = (crmContactsCreateResponseSuccess)

export const getCrmContactsCreateUrl = () => {


  

  return `/api/v1/crm/contacts/`
}

export const crmContactsCreate = async (contactRequest: ContactRequest, options?: RequestInit): Promise<crmContactsCreateResponse> => {
  
  return apiFetch<crmContactsCreateResponse>(getCrmContactsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contactRequest,)
  }
);}




export const getCrmContactsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsCreate>>, TError,{data: ContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsCreate>>, TError,{data: ContactRequest}, TContext> => {

const mutationKey = ['crmContactsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsCreate>>, {data: ContactRequest}> = (props) => {
          const {data} = props ?? {};

          return  crmContactsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsCreate>>>
    export type CrmContactsCreateMutationBody = ContactRequest
    export type CrmContactsCreateMutationError = unknown

    export const useCrmContactsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsCreate>>, TError,{data: ContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsCreate>>,
        TError,
        {data: ContactRequest},
        TContext
      > => {

      const mutationOptions = getCrmContactsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmContactsRetrieveResponse200 = {
  data: Contact
  status: 200
}
    
export type crmContactsRetrieveResponseSuccess = (crmContactsRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmContactsRetrieveResponse = (crmContactsRetrieveResponseSuccess)

export const getCrmContactsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/`
}

export const crmContactsRetrieve = async (id: string, options?: RequestInit): Promise<crmContactsRetrieveResponse> => {
  
  return apiFetch<crmContactsRetrieveResponse>(getCrmContactsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmContactsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/contacts/${id}/`
    ] as const;
    }

    
export const getCrmContactsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmContactsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmContactsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmContactsRetrieve>>> = ({ signal }) => crmContactsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmContactsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmContactsRetrieve>>>
export type CrmContactsRetrieveQueryError = unknown


export function useCrmContactsRetrieve<TData = Awaited<ReturnType<typeof crmContactsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmContactsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsRetrieve<TData = Awaited<ReturnType<typeof crmContactsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmContactsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsRetrieve<TData = Awaited<ReturnType<typeof crmContactsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmContactsRetrieve<TData = Awaited<ReturnType<typeof crmContactsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmContactsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmContactsUpdateResponse200 = {
  data: Contact
  status: 200
}
    
export type crmContactsUpdateResponseSuccess = (crmContactsUpdateResponse200) & {
  headers: Headers;
};
;

export type crmContactsUpdateResponse = (crmContactsUpdateResponseSuccess)

export const getCrmContactsUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/`
}

export const crmContactsUpdate = async (id: string,
    contactRequest: ContactRequest, options?: RequestInit): Promise<crmContactsUpdateResponse> => {
  
  return apiFetch<crmContactsUpdateResponse>(getCrmContactsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contactRequest,)
  }
);}




export const getCrmContactsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsUpdate>>, TError,{id: string;data: ContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsUpdate>>, TError,{id: string;data: ContactRequest}, TContext> => {

const mutationKey = ['crmContactsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsUpdate>>, {id: string;data: ContactRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmContactsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsUpdate>>>
    export type CrmContactsUpdateMutationBody = ContactRequest
    export type CrmContactsUpdateMutationError = unknown

    export const useCrmContactsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsUpdate>>, TError,{id: string;data: ContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsUpdate>>,
        TError,
        {id: string;data: ContactRequest},
        TContext
      > => {

      const mutationOptions = getCrmContactsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmContactsPartialUpdateResponse200 = {
  data: Contact
  status: 200
}
    
export type crmContactsPartialUpdateResponseSuccess = (crmContactsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type crmContactsPartialUpdateResponse = (crmContactsPartialUpdateResponseSuccess)

export const getCrmContactsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/`
}

export const crmContactsPartialUpdate = async (id: string,
    patchedContactRequest: PatchedContactRequest, options?: RequestInit): Promise<crmContactsPartialUpdateResponse> => {
  
  return apiFetch<crmContactsPartialUpdateResponse>(getCrmContactsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedContactRequest,)
  }
);}




export const getCrmContactsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsPartialUpdate>>, TError,{id: string;data: PatchedContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsPartialUpdate>>, TError,{id: string;data: PatchedContactRequest}, TContext> => {

const mutationKey = ['crmContactsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsPartialUpdate>>, {id: string;data: PatchedContactRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmContactsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsPartialUpdate>>>
    export type CrmContactsPartialUpdateMutationBody = PatchedContactRequest
    export type CrmContactsPartialUpdateMutationError = unknown

    export const useCrmContactsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsPartialUpdate>>, TError,{id: string;data: PatchedContactRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsPartialUpdate>>,
        TError,
        {id: string;data: PatchedContactRequest},
        TContext
      > => {

      const mutationOptions = getCrmContactsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Right to erasure (law 2024/017): irreversible, statistics kept.
 */
export type crmContactsEraseCreateResponse200 = {
  data: Contact
  status: 200
}
    
export type crmContactsEraseCreateResponseSuccess = (crmContactsEraseCreateResponse200) & {
  headers: Headers;
};
;

export type crmContactsEraseCreateResponse = (crmContactsEraseCreateResponseSuccess)

export const getCrmContactsEraseCreateUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/erase/`
}

export const crmContactsEraseCreate = async (id: string, options?: RequestInit): Promise<crmContactsEraseCreateResponse> => {
  
  return apiFetch<crmContactsEraseCreateResponse>(getCrmContactsEraseCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCrmContactsEraseCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsEraseCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsEraseCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['crmContactsEraseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsEraseCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  crmContactsEraseCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsEraseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsEraseCreate>>>
    
    export type CrmContactsEraseCreateMutationError = unknown

    export const useCrmContactsEraseCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsEraseCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsEraseCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCrmContactsEraseCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Right of access (law 2024/017): the person's data in one file.
 */
export type crmContactsExportRetrieveResponse200 = {
  data: CrmContactsExportRetrieve200
  status: 200
}
    
export type crmContactsExportRetrieveResponseSuccess = (crmContactsExportRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmContactsExportRetrieveResponse = (crmContactsExportRetrieveResponseSuccess)

export const getCrmContactsExportRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/export/`
}

export const crmContactsExportRetrieve = async (id: string, options?: RequestInit): Promise<crmContactsExportRetrieveResponse> => {
  
  return apiFetch<crmContactsExportRetrieveResponse>(getCrmContactsExportRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmContactsExportRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/contacts/${id}/export/`
    ] as const;
    }

    
export const getCrmContactsExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmContactsExportRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmContactsExportRetrieve>>> = ({ signal }) => crmContactsExportRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmContactsExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmContactsExportRetrieve>>>
export type CrmContactsExportRetrieveQueryError = unknown


export function useCrmContactsExportRetrieve<TData = Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmContactsExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsExportRetrieve<TData = Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmContactsExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsExportRetrieve<TData = Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmContactsExportRetrieve<TData = Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmContactsExportRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Merge this duplicate into another contact (the leads move).
 */
export type crmContactsMergeCreateResponse200 = {
  data: Contact
  status: 200
}
    
export type crmContactsMergeCreateResponseSuccess = (crmContactsMergeCreateResponse200) & {
  headers: Headers;
};
;

export type crmContactsMergeCreateResponse = (crmContactsMergeCreateResponseSuccess)

export const getCrmContactsMergeCreateUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/merge/`
}

export const crmContactsMergeCreate = async (id: string,
    mergeRequest: MergeRequest, options?: RequestInit): Promise<crmContactsMergeCreateResponse> => {
  
  return apiFetch<crmContactsMergeCreateResponse>(getCrmContactsMergeCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mergeRequest,)
  }
);}




export const getCrmContactsMergeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsMergeCreate>>, TError,{id: string;data: MergeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsMergeCreate>>, TError,{id: string;data: MergeRequest}, TContext> => {

const mutationKey = ['crmContactsMergeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsMergeCreate>>, {id: string;data: MergeRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmContactsMergeCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsMergeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsMergeCreate>>>
    export type CrmContactsMergeCreateMutationBody = MergeRequest
    export type CrmContactsMergeCreateMutationError = unknown

    export const useCrmContactsMergeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsMergeCreate>>, TError,{id: string;data: MergeRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsMergeCreate>>,
        TError,
        {id: string;data: MergeRequest},
        TContext
      > => {

      const mutationOptions = getCrmContactsMergeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * P4-05: the contact's referral code (created once), to share with friends.
 */
export type crmContactsReferralCodeCreateResponse200 = {
  data: ReferralCode
  status: 200
}
    
export type crmContactsReferralCodeCreateResponseSuccess = (crmContactsReferralCodeCreateResponse200) & {
  headers: Headers;
};
;

export type crmContactsReferralCodeCreateResponse = (crmContactsReferralCodeCreateResponseSuccess)

export const getCrmContactsReferralCodeCreateUrl = (id: string,) => {


  

  return `/api/v1/crm/contacts/${id}/referral-code/`
}

export const crmContactsReferralCodeCreate = async (id: string, options?: RequestInit): Promise<crmContactsReferralCodeCreateResponse> => {
  
  return apiFetch<crmContactsReferralCodeCreateResponse>(getCrmContactsReferralCodeCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getCrmContactsReferralCodeCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['crmContactsReferralCodeCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  crmContactsReferralCodeCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsReferralCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>>
    
    export type CrmContactsReferralCodeCreateMutationError = unknown

    export const useCrmContactsReferralCodeCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsReferralCodeCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCrmContactsReferralCodeCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-126: contacts already known with this e-mail or number (whoever follows them).
 */
export type crmContactsDuplicatesListResponse200 = {
  data: Duplicate[]
  status: 200
}
    
export type crmContactsDuplicatesListResponseSuccess = (crmContactsDuplicatesListResponse200) & {
  headers: Headers;
};
;

export type crmContactsDuplicatesListResponse = (crmContactsDuplicatesListResponseSuccess)

export const getCrmContactsDuplicatesListUrl = (params?: CrmContactsDuplicatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/contacts/duplicates/?${stringifiedParams}` : `/api/v1/crm/contacts/duplicates/`
}

export const crmContactsDuplicatesList = async (params?: CrmContactsDuplicatesListParams, options?: RequestInit): Promise<crmContactsDuplicatesListResponse> => {
  
  return apiFetch<crmContactsDuplicatesListResponse>(getCrmContactsDuplicatesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmContactsDuplicatesListQueryKey = (params?: CrmContactsDuplicatesListParams,) => {
    return [
    `/api/v1/crm/contacts/duplicates/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmContactsDuplicatesListQueryOptions = <TData = Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError = unknown>(params?: CrmContactsDuplicatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmContactsDuplicatesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmContactsDuplicatesList>>> = ({ signal }) => crmContactsDuplicatesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmContactsDuplicatesListQueryResult = NonNullable<Awaited<ReturnType<typeof crmContactsDuplicatesList>>>
export type CrmContactsDuplicatesListQueryError = unknown


export function useCrmContactsDuplicatesList<TData = Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError = unknown>(
 params: undefined |  CrmContactsDuplicatesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsDuplicatesList>>,
          TError,
          Awaited<ReturnType<typeof crmContactsDuplicatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsDuplicatesList<TData = Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError = unknown>(
 params?: CrmContactsDuplicatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmContactsDuplicatesList>>,
          TError,
          Awaited<ReturnType<typeof crmContactsDuplicatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmContactsDuplicatesList<TData = Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError = unknown>(
 params?: CrmContactsDuplicatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmContactsDuplicatesList<TData = Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError = unknown>(
 params?: CrmContactsDuplicatesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmContactsDuplicatesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmContactsDuplicatesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * D-126: add a client by hand. A known e-mail or number is refused with the existing
contact (to open their sheet, or turn their lead into a client).
 */
export type crmContactsNewClientCreateResponse201 = {
  data: Lead
  status: 201
}
    
export type crmContactsNewClientCreateResponseSuccess = (crmContactsNewClientCreateResponse201) & {
  headers: Headers;
};
;

export type crmContactsNewClientCreateResponse = (crmContactsNewClientCreateResponseSuccess)

export const getCrmContactsNewClientCreateUrl = () => {


  

  return `/api/v1/crm/contacts/new-client/`
}

export const crmContactsNewClientCreate = async (newClientRequest: NewClientRequest, options?: RequestInit): Promise<crmContactsNewClientCreateResponse> => {
  
  return apiFetch<crmContactsNewClientCreateResponse>(getCrmContactsNewClientCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      newClientRequest,)
  }
);}




export const getCrmContactsNewClientCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsNewClientCreate>>, TError,{data: NewClientRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmContactsNewClientCreate>>, TError,{data: NewClientRequest}, TContext> => {

const mutationKey = ['crmContactsNewClientCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmContactsNewClientCreate>>, {data: NewClientRequest}> = (props) => {
          const {data} = props ?? {};

          return  crmContactsNewClientCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmContactsNewClientCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmContactsNewClientCreate>>>
    export type CrmContactsNewClientCreateMutationBody = NewClientRequest
    export type CrmContactsNewClientCreateMutationError = unknown

    export const useCrmContactsNewClientCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmContactsNewClientCreate>>, TError,{data: NewClientRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmContactsNewClientCreate>>,
        TError,
        {data: NewClientRequest},
        TContext
      > => {

      const mutationOptions = getCrmContactsNewClientCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmFollowUpSettingsListResponse200 = {
  data: PaginatedFollowUpSettingsList
  status: 200
}
    
export type crmFollowUpSettingsListResponseSuccess = (crmFollowUpSettingsListResponse200) & {
  headers: Headers;
};
;

export type crmFollowUpSettingsListResponse = (crmFollowUpSettingsListResponseSuccess)

export const getCrmFollowUpSettingsListUrl = (params?: CrmFollowUpSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/follow-up-settings/?${stringifiedParams}` : `/api/v1/crm/follow-up-settings/`
}

export const crmFollowUpSettingsList = async (params?: CrmFollowUpSettingsListParams, options?: RequestInit): Promise<crmFollowUpSettingsListResponse> => {
  
  return apiFetch<crmFollowUpSettingsListResponse>(getCrmFollowUpSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmFollowUpSettingsListQueryKey = (params?: CrmFollowUpSettingsListParams,) => {
    return [
    `/api/v1/crm/follow-up-settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmFollowUpSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError = unknown>(params?: CrmFollowUpSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmFollowUpSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmFollowUpSettingsList>>> = ({ signal }) => crmFollowUpSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmFollowUpSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof crmFollowUpSettingsList>>>
export type CrmFollowUpSettingsListQueryError = unknown


export function useCrmFollowUpSettingsList<TData = Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError = unknown>(
 params: undefined |  CrmFollowUpSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmFollowUpSettingsList>>,
          TError,
          Awaited<ReturnType<typeof crmFollowUpSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmFollowUpSettingsList<TData = Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError = unknown>(
 params?: CrmFollowUpSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmFollowUpSettingsList>>,
          TError,
          Awaited<ReturnType<typeof crmFollowUpSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmFollowUpSettingsList<TData = Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError = unknown>(
 params?: CrmFollowUpSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmFollowUpSettingsList<TData = Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError = unknown>(
 params?: CrmFollowUpSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmFollowUpSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmFollowUpSettingsRetrieveResponse200 = {
  data: FollowUpSettings
  status: 200
}
    
export type crmFollowUpSettingsRetrieveResponseSuccess = (crmFollowUpSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmFollowUpSettingsRetrieveResponse = (crmFollowUpSettingsRetrieveResponseSuccess)

export const getCrmFollowUpSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/follow-up-settings/${id}/`
}

export const crmFollowUpSettingsRetrieve = async (id: string, options?: RequestInit): Promise<crmFollowUpSettingsRetrieveResponse> => {
  
  return apiFetch<crmFollowUpSettingsRetrieveResponse>(getCrmFollowUpSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmFollowUpSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/follow-up-settings/${id}/`
    ] as const;
    }

    
export const getCrmFollowUpSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmFollowUpSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>> = ({ signal }) => crmFollowUpSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmFollowUpSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>>
export type CrmFollowUpSettingsRetrieveQueryError = unknown


export function useCrmFollowUpSettingsRetrieve<TData = Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmFollowUpSettingsRetrieve<TData = Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmFollowUpSettingsRetrieve<TData = Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmFollowUpSettingsRetrieve<TData = Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmFollowUpSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmFollowUpSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmFollowUpSettingsUpdateResponse200 = {
  data: FollowUpSettings
  status: 200
}
    
export type crmFollowUpSettingsUpdateResponseSuccess = (crmFollowUpSettingsUpdateResponse200) & {
  headers: Headers;
};
;

export type crmFollowUpSettingsUpdateResponse = (crmFollowUpSettingsUpdateResponseSuccess)

export const getCrmFollowUpSettingsUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/follow-up-settings/${id}/`
}

export const crmFollowUpSettingsUpdate = async (id: string,
    followUpSettingsRequest: FollowUpSettingsRequest, options?: RequestInit): Promise<crmFollowUpSettingsUpdateResponse> => {
  
  return apiFetch<crmFollowUpSettingsUpdateResponse>(getCrmFollowUpSettingsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      followUpSettingsRequest,)
  }
);}




export const getCrmFollowUpSettingsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>, TError,{id: string;data: FollowUpSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>, TError,{id: string;data: FollowUpSettingsRequest}, TContext> => {

const mutationKey = ['crmFollowUpSettingsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>, {id: string;data: FollowUpSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmFollowUpSettingsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmFollowUpSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>>
    export type CrmFollowUpSettingsUpdateMutationBody = FollowUpSettingsRequest
    export type CrmFollowUpSettingsUpdateMutationError = unknown

    export const useCrmFollowUpSettingsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>, TError,{id: string;data: FollowUpSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmFollowUpSettingsUpdate>>,
        TError,
        {id: string;data: FollowUpSettingsRequest},
        TContext
      > => {

      const mutationOptions = getCrmFollowUpSettingsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmFollowUpSettingsPartialUpdateResponse200 = {
  data: FollowUpSettings
  status: 200
}
    
export type crmFollowUpSettingsPartialUpdateResponseSuccess = (crmFollowUpSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type crmFollowUpSettingsPartialUpdateResponse = (crmFollowUpSettingsPartialUpdateResponseSuccess)

export const getCrmFollowUpSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/follow-up-settings/${id}/`
}

export const crmFollowUpSettingsPartialUpdate = async (id: string,
    patchedFollowUpSettingsRequest: PatchedFollowUpSettingsRequest, options?: RequestInit): Promise<crmFollowUpSettingsPartialUpdateResponse> => {
  
  return apiFetch<crmFollowUpSettingsPartialUpdateResponse>(getCrmFollowUpSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedFollowUpSettingsRequest,)
  }
);}




export const getCrmFollowUpSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>, TError,{id: string;data: PatchedFollowUpSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>, TError,{id: string;data: PatchedFollowUpSettingsRequest}, TContext> => {

const mutationKey = ['crmFollowUpSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>, {id: string;data: PatchedFollowUpSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmFollowUpSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmFollowUpSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>>
    export type CrmFollowUpSettingsPartialUpdateMutationBody = PatchedFollowUpSettingsRequest
    export type CrmFollowUpSettingsPartialUpdateMutationError = unknown

    export const useCrmFollowUpSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>, TError,{id: string;data: PatchedFollowUpSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmFollowUpSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedFollowUpSettingsRequest},
        TContext
      > => {

      const mutationOptions = getCrmFollowUpSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsListResponse200 = {
  data: PaginatedLeadList
  status: 200
}
    
export type crmLeadsListResponseSuccess = (crmLeadsListResponse200) & {
  headers: Headers;
};
;

export type crmLeadsListResponse = (crmLeadsListResponseSuccess)

export const getCrmLeadsListUrl = (params?: CrmLeadsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/leads/?${stringifiedParams}` : `/api/v1/crm/leads/`
}

export const crmLeadsList = async (params?: CrmLeadsListParams, options?: RequestInit): Promise<crmLeadsListResponse> => {
  
  return apiFetch<crmLeadsListResponse>(getCrmLeadsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmLeadsListQueryKey = (params?: CrmLeadsListParams,) => {
    return [
    `/api/v1/crm/leads/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmLeadsListQueryOptions = <TData = Awaited<ReturnType<typeof crmLeadsList>>, TError = unknown>(params?: CrmLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmLeadsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmLeadsList>>> = ({ signal }) => crmLeadsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmLeadsListQueryResult = NonNullable<Awaited<ReturnType<typeof crmLeadsList>>>
export type CrmLeadsListQueryError = unknown


export function useCrmLeadsList<TData = Awaited<ReturnType<typeof crmLeadsList>>, TError = unknown>(
 params: undefined |  CrmLeadsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsList<TData = Awaited<ReturnType<typeof crmLeadsList>>, TError = unknown>(
 params?: CrmLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsList<TData = Awaited<ReturnType<typeof crmLeadsList>>, TError = unknown>(
 params?: CrmLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmLeadsList<TData = Awaited<ReturnType<typeof crmLeadsList>>, TError = unknown>(
 params?: CrmLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmLeadsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmLeadsCreateResponse201 = {
  data: Lead
  status: 201
}
    
export type crmLeadsCreateResponseSuccess = (crmLeadsCreateResponse201) & {
  headers: Headers;
};
;

export type crmLeadsCreateResponse = (crmLeadsCreateResponseSuccess)

export const getCrmLeadsCreateUrl = () => {


  

  return `/api/v1/crm/leads/`
}

export const crmLeadsCreate = async (leadRequest: LeadRequest, options?: RequestInit): Promise<crmLeadsCreateResponse> => {
  
  return apiFetch<crmLeadsCreateResponse>(getCrmLeadsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadRequest,)
  }
);}




export const getCrmLeadsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsCreate>>, TError,{data: LeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsCreate>>, TError,{data: LeadRequest}, TContext> => {

const mutationKey = ['crmLeadsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsCreate>>, {data: LeadRequest}> = (props) => {
          const {data} = props ?? {};

          return  crmLeadsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsCreate>>>
    export type CrmLeadsCreateMutationBody = LeadRequest
    export type CrmLeadsCreateMutationError = unknown

    export const useCrmLeadsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsCreate>>, TError,{data: LeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsCreate>>,
        TError,
        {data: LeadRequest},
        TContext
      > => {

      const mutationOptions = getCrmLeadsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsRetrieveResponse200 = {
  data: Lead
  status: 200
}
    
export type crmLeadsRetrieveResponseSuccess = (crmLeadsRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmLeadsRetrieveResponse = (crmLeadsRetrieveResponseSuccess)

export const getCrmLeadsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/`
}

export const crmLeadsRetrieve = async (id: string, options?: RequestInit): Promise<crmLeadsRetrieveResponse> => {
  
  return apiFetch<crmLeadsRetrieveResponse>(getCrmLeadsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmLeadsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/leads/${id}/`
    ] as const;
    }

    
export const getCrmLeadsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmLeadsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmLeadsRetrieve>>> = ({ signal }) => crmLeadsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmLeadsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmLeadsRetrieve>>>
export type CrmLeadsRetrieveQueryError = unknown


export function useCrmLeadsRetrieve<TData = Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsRetrieve<TData = Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsRetrieve<TData = Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmLeadsRetrieve<TData = Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmLeadsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmLeadsUpdateResponse200 = {
  data: Lead
  status: 200
}
    
export type crmLeadsUpdateResponseSuccess = (crmLeadsUpdateResponse200) & {
  headers: Headers;
};
;

export type crmLeadsUpdateResponse = (crmLeadsUpdateResponseSuccess)

export const getCrmLeadsUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/`
}

export const crmLeadsUpdate = async (id: string,
    leadRequest: LeadRequest, options?: RequestInit): Promise<crmLeadsUpdateResponse> => {
  
  return apiFetch<crmLeadsUpdateResponse>(getCrmLeadsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      leadRequest,)
  }
);}




export const getCrmLeadsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsUpdate>>, TError,{id: string;data: LeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsUpdate>>, TError,{id: string;data: LeadRequest}, TContext> => {

const mutationKey = ['crmLeadsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsUpdate>>, {id: string;data: LeadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmLeadsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsUpdate>>>
    export type CrmLeadsUpdateMutationBody = LeadRequest
    export type CrmLeadsUpdateMutationError = unknown

    export const useCrmLeadsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsUpdate>>, TError,{id: string;data: LeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsUpdate>>,
        TError,
        {id: string;data: LeadRequest},
        TContext
      > => {

      const mutationOptions = getCrmLeadsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsPartialUpdateResponse200 = {
  data: Lead
  status: 200
}
    
export type crmLeadsPartialUpdateResponseSuccess = (crmLeadsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type crmLeadsPartialUpdateResponse = (crmLeadsPartialUpdateResponseSuccess)

export const getCrmLeadsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/`
}

export const crmLeadsPartialUpdate = async (id: string,
    patchedLeadRequest: PatchedLeadRequest, options?: RequestInit): Promise<crmLeadsPartialUpdateResponse> => {
  
  return apiFetch<crmLeadsPartialUpdateResponse>(getCrmLeadsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLeadRequest,)
  }
);}




export const getCrmLeadsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsPartialUpdate>>, TError,{id: string;data: PatchedLeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsPartialUpdate>>, TError,{id: string;data: PatchedLeadRequest}, TContext> => {

const mutationKey = ['crmLeadsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsPartialUpdate>>, {id: string;data: PatchedLeadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmLeadsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsPartialUpdate>>>
    export type CrmLeadsPartialUpdateMutationBody = PatchedLeadRequest
    export type CrmLeadsPartialUpdateMutationError = unknown

    export const useCrmLeadsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsPartialUpdate>>, TError,{id: string;data: PatchedLeadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsPartialUpdate>>,
        TError,
        {id: string;data: PatchedLeadRequest},
        TContext
      > => {

      const mutationOptions = getCrmLeadsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type crmLeadsDestroyResponseSuccess = (crmLeadsDestroyResponse204) & {
  headers: Headers;
};
;

export type crmLeadsDestroyResponse = (crmLeadsDestroyResponseSuccess)

export const getCrmLeadsDestroyUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/`
}

export const crmLeadsDestroy = async (id: string, options?: RequestInit): Promise<crmLeadsDestroyResponse> => {
  
  return apiFetch<crmLeadsDestroyResponse>(getCrmLeadsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getCrmLeadsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['crmLeadsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  crmLeadsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsDestroy>>>
    
    export type CrmLeadsDestroyMutationError = unknown

    export const useCrmLeadsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCrmLeadsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsActivitiesListResponse200 = {
  data: Activity[]
  status: 200
}
    
export type crmLeadsActivitiesListResponseSuccess = (crmLeadsActivitiesListResponse200) & {
  headers: Headers;
};
;

export type crmLeadsActivitiesListResponse = (crmLeadsActivitiesListResponseSuccess)

export const getCrmLeadsActivitiesListUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/activities/`
}

export const crmLeadsActivitiesList = async (id: string, options?: RequestInit): Promise<crmLeadsActivitiesListResponse> => {
  
  return apiFetch<crmLeadsActivitiesListResponse>(getCrmLeadsActivitiesListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmLeadsActivitiesListQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/leads/${id}/activities/`
    ] as const;
    }

    
export const getCrmLeadsActivitiesListQueryOptions = <TData = Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmLeadsActivitiesListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmLeadsActivitiesList>>> = ({ signal }) => crmLeadsActivitiesList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmLeadsActivitiesListQueryResult = NonNullable<Awaited<ReturnType<typeof crmLeadsActivitiesList>>>
export type CrmLeadsActivitiesListQueryError = unknown


export function useCrmLeadsActivitiesList<TData = Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsActivitiesList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsActivitiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsActivitiesList<TData = Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsActivitiesList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsActivitiesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsActivitiesList<TData = Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmLeadsActivitiesList<TData = Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsActivitiesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmLeadsActivitiesListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmLeadsActivitiesCreateResponse201 = {
  data: Activity
  status: 201
}
    
export type crmLeadsActivitiesCreateResponseSuccess = (crmLeadsActivitiesCreateResponse201) & {
  headers: Headers;
};
;

export type crmLeadsActivitiesCreateResponse = (crmLeadsActivitiesCreateResponseSuccess)

export const getCrmLeadsActivitiesCreateUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/activities/`
}

export const crmLeadsActivitiesCreate = async (id: string,
    activityRequest: ActivityRequest, options?: RequestInit): Promise<crmLeadsActivitiesCreateResponse> => {
  
  return apiFetch<crmLeadsActivitiesCreateResponse>(getCrmLeadsActivitiesCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activityRequest,)
  }
);}




export const getCrmLeadsActivitiesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>, TError,{id: string;data: ActivityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>, TError,{id: string;data: ActivityRequest}, TContext> => {

const mutationKey = ['crmLeadsActivitiesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>, {id: string;data: ActivityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmLeadsActivitiesCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsActivitiesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>>
    export type CrmLeadsActivitiesCreateMutationBody = ActivityRequest
    export type CrmLeadsActivitiesCreateMutationError = unknown

    export const useCrmLeadsActivitiesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>, TError,{id: string;data: ActivityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsActivitiesCreate>>,
        TError,
        {id: string;data: ActivityRequest},
        TContext
      > => {

      const mutationOptions = getCrmLeadsActivitiesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmLeadsHistoryListResponse200 = {
  data: StageChange[]
  status: 200
}
    
export type crmLeadsHistoryListResponseSuccess = (crmLeadsHistoryListResponse200) & {
  headers: Headers;
};
;

export type crmLeadsHistoryListResponse = (crmLeadsHistoryListResponseSuccess)

export const getCrmLeadsHistoryListUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/history/`
}

export const crmLeadsHistoryList = async (id: string, options?: RequestInit): Promise<crmLeadsHistoryListResponse> => {
  
  return apiFetch<crmLeadsHistoryListResponse>(getCrmLeadsHistoryListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmLeadsHistoryListQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/leads/${id}/history/`
    ] as const;
    }

    
export const getCrmLeadsHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmLeadsHistoryListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmLeadsHistoryList>>> = ({ signal }) => crmLeadsHistoryList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmLeadsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof crmLeadsHistoryList>>>
export type CrmLeadsHistoryListQueryError = unknown


export function useCrmLeadsHistoryList<TData = Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsHistoryList<TData = Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsHistoryList>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsHistoryList<TData = Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmLeadsHistoryList<TData = Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsHistoryList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmLeadsHistoryListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Kanban: move the lead to another stage (history kept, lost needs a reason).
 */
export type crmLeadsMoveCreateResponse200 = {
  data: Lead
  status: 200
}
    
export type crmLeadsMoveCreateResponseSuccess = (crmLeadsMoveCreateResponse200) & {
  headers: Headers;
};
;

export type crmLeadsMoveCreateResponse = (crmLeadsMoveCreateResponseSuccess)

export const getCrmLeadsMoveCreateUrl = (id: string,) => {


  

  return `/api/v1/crm/leads/${id}/move/`
}

export const crmLeadsMoveCreate = async (id: string,
    moveRequest: MoveRequest, options?: RequestInit): Promise<crmLeadsMoveCreateResponse> => {
  
  return apiFetch<crmLeadsMoveCreateResponse>(getCrmLeadsMoveCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      moveRequest,)
  }
);}




export const getCrmLeadsMoveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsMoveCreate>>, TError,{id: string;data: MoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmLeadsMoveCreate>>, TError,{id: string;data: MoveRequest}, TContext> => {

const mutationKey = ['crmLeadsMoveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmLeadsMoveCreate>>, {id: string;data: MoveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmLeadsMoveCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmLeadsMoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof crmLeadsMoveCreate>>>
    export type CrmLeadsMoveCreateMutationBody = MoveRequest
    export type CrmLeadsMoveCreateMutationError = unknown

    export const useCrmLeadsMoveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmLeadsMoveCreate>>, TError,{id: string;data: MoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmLeadsMoveCreate>>,
        TError,
        {id: string;data: MoveRequest},
        TContext
      > => {

      const mutationOptions = getCrmLeadsMoveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-115: leads per stage, counted in the database (every lead the user may see).
 */
export type crmLeadsPipelineRetrieveResponse200 = {
  data: LeadPipeline
  status: 200
}
    
export type crmLeadsPipelineRetrieveResponseSuccess = (crmLeadsPipelineRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmLeadsPipelineRetrieveResponse = (crmLeadsPipelineRetrieveResponseSuccess)

export const getCrmLeadsPipelineRetrieveUrl = () => {


  

  return `/api/v1/crm/leads/pipeline/`
}

export const crmLeadsPipelineRetrieve = async ( options?: RequestInit): Promise<crmLeadsPipelineRetrieveResponse> => {
  
  return apiFetch<crmLeadsPipelineRetrieveResponse>(getCrmLeadsPipelineRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmLeadsPipelineRetrieveQueryKey = () => {
    return [
    `/api/v1/crm/leads/pipeline/`
    ] as const;
    }

    
export const getCrmLeadsPipelineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmLeadsPipelineRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>> = ({ signal }) => crmLeadsPipelineRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmLeadsPipelineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>>
export type CrmLeadsPipelineRetrieveQueryError = unknown


export function useCrmLeadsPipelineRetrieve<TData = Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsPipelineRetrieve<TData = Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmLeadsPipelineRetrieve<TData = Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmLeadsPipelineRetrieve<TData = Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmLeadsPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmLeadsPipelineRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The agency's team (to assign a lead).
 */
export type crmMembersListResponse200 = {
  data: Member[]
  status: 200
}
    
export type crmMembersListResponseSuccess = (crmMembersListResponse200) & {
  headers: Headers;
};
;

export type crmMembersListResponse = (crmMembersListResponseSuccess)

export const getCrmMembersListUrl = () => {


  

  return `/api/v1/crm/members/`
}

export const crmMembersList = async ( options?: RequestInit): Promise<crmMembersListResponse> => {
  
  return apiFetch<crmMembersListResponse>(getCrmMembersListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmMembersListQueryKey = () => {
    return [
    `/api/v1/crm/members/`
    ] as const;
    }

    
export const getCrmMembersListQueryOptions = <TData = Awaited<ReturnType<typeof crmMembersList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmMembersListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmMembersList>>> = ({ signal }) => crmMembersList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof crmMembersList>>>
export type CrmMembersListQueryError = unknown


export function useCrmMembersList<TData = Awaited<ReturnType<typeof crmMembersList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmMembersList>>,
          TError,
          Awaited<ReturnType<typeof crmMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmMembersList<TData = Awaited<ReturnType<typeof crmMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmMembersList>>,
          TError,
          Awaited<ReturnType<typeof crmMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmMembersList<TData = Awaited<ReturnType<typeof crmMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmMembersList<TData = Awaited<ReturnType<typeof crmMembersList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmMembersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmMembersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmReferralProgramListResponse200 = {
  data: PaginatedReferralProgramList
  status: 200
}
    
export type crmReferralProgramListResponseSuccess = (crmReferralProgramListResponse200) & {
  headers: Headers;
};
;

export type crmReferralProgramListResponse = (crmReferralProgramListResponseSuccess)

export const getCrmReferralProgramListUrl = (params?: CrmReferralProgramListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/referral-program/?${stringifiedParams}` : `/api/v1/crm/referral-program/`
}

export const crmReferralProgramList = async (params?: CrmReferralProgramListParams, options?: RequestInit): Promise<crmReferralProgramListResponse> => {
  
  return apiFetch<crmReferralProgramListResponse>(getCrmReferralProgramListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmReferralProgramListQueryKey = (params?: CrmReferralProgramListParams,) => {
    return [
    `/api/v1/crm/referral-program/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmReferralProgramListQueryOptions = <TData = Awaited<ReturnType<typeof crmReferralProgramList>>, TError = unknown>(params?: CrmReferralProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmReferralProgramListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmReferralProgramList>>> = ({ signal }) => crmReferralProgramList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmReferralProgramListQueryResult = NonNullable<Awaited<ReturnType<typeof crmReferralProgramList>>>
export type CrmReferralProgramListQueryError = unknown


export function useCrmReferralProgramList<TData = Awaited<ReturnType<typeof crmReferralProgramList>>, TError = unknown>(
 params: undefined |  CrmReferralProgramListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralProgramList>>,
          TError,
          Awaited<ReturnType<typeof crmReferralProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralProgramList<TData = Awaited<ReturnType<typeof crmReferralProgramList>>, TError = unknown>(
 params?: CrmReferralProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralProgramList>>,
          TError,
          Awaited<ReturnType<typeof crmReferralProgramList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralProgramList<TData = Awaited<ReturnType<typeof crmReferralProgramList>>, TError = unknown>(
 params?: CrmReferralProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmReferralProgramList<TData = Awaited<ReturnType<typeof crmReferralProgramList>>, TError = unknown>(
 params?: CrmReferralProgramListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmReferralProgramListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmReferralProgramRetrieveResponse200 = {
  data: ReferralProgram
  status: 200
}
    
export type crmReferralProgramRetrieveResponseSuccess = (crmReferralProgramRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmReferralProgramRetrieveResponse = (crmReferralProgramRetrieveResponseSuccess)

export const getCrmReferralProgramRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/referral-program/${id}/`
}

export const crmReferralProgramRetrieve = async (id: string, options?: RequestInit): Promise<crmReferralProgramRetrieveResponse> => {
  
  return apiFetch<crmReferralProgramRetrieveResponse>(getCrmReferralProgramRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmReferralProgramRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/referral-program/${id}/`
    ] as const;
    }

    
export const getCrmReferralProgramRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmReferralProgramRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>> = ({ signal }) => crmReferralProgramRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmReferralProgramRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>>
export type CrmReferralProgramRetrieveQueryError = unknown


export function useCrmReferralProgramRetrieve<TData = Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralProgramRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmReferralProgramRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralProgramRetrieve<TData = Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralProgramRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmReferralProgramRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralProgramRetrieve<TData = Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmReferralProgramRetrieve<TData = Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralProgramRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmReferralProgramRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmReferralProgramUpdateResponse200 = {
  data: ReferralProgram
  status: 200
}
    
export type crmReferralProgramUpdateResponseSuccess = (crmReferralProgramUpdateResponse200) & {
  headers: Headers;
};
;

export type crmReferralProgramUpdateResponse = (crmReferralProgramUpdateResponseSuccess)

export const getCrmReferralProgramUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/referral-program/${id}/`
}

export const crmReferralProgramUpdate = async (id: string,
    referralProgramRequest: ReferralProgramRequest, options?: RequestInit): Promise<crmReferralProgramUpdateResponse> => {
  
  return apiFetch<crmReferralProgramUpdateResponse>(getCrmReferralProgramUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      referralProgramRequest,)
  }
);}




export const getCrmReferralProgramUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramUpdate>>, TError,{id: string;data: ReferralProgramRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramUpdate>>, TError,{id: string;data: ReferralProgramRequest}, TContext> => {

const mutationKey = ['crmReferralProgramUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmReferralProgramUpdate>>, {id: string;data: ReferralProgramRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmReferralProgramUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmReferralProgramUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmReferralProgramUpdate>>>
    export type CrmReferralProgramUpdateMutationBody = ReferralProgramRequest
    export type CrmReferralProgramUpdateMutationError = unknown

    export const useCrmReferralProgramUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramUpdate>>, TError,{id: string;data: ReferralProgramRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmReferralProgramUpdate>>,
        TError,
        {id: string;data: ReferralProgramRequest},
        TContext
      > => {

      const mutationOptions = getCrmReferralProgramUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One row per agency, created with safe defaults on first read (all automations off).
 */
export type crmReferralProgramPartialUpdateResponse200 = {
  data: ReferralProgram
  status: 200
}
    
export type crmReferralProgramPartialUpdateResponseSuccess = (crmReferralProgramPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type crmReferralProgramPartialUpdateResponse = (crmReferralProgramPartialUpdateResponseSuccess)

export const getCrmReferralProgramPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/crm/referral-program/${id}/`
}

export const crmReferralProgramPartialUpdate = async (id: string,
    patchedReferralProgramRequest: PatchedReferralProgramRequest, options?: RequestInit): Promise<crmReferralProgramPartialUpdateResponse> => {
  
  return apiFetch<crmReferralProgramPartialUpdateResponse>(getCrmReferralProgramPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedReferralProgramRequest,)
  }
);}




export const getCrmReferralProgramPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>, TError,{id: string;data: PatchedReferralProgramRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>, TError,{id: string;data: PatchedReferralProgramRequest}, TContext> => {

const mutationKey = ['crmReferralProgramPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>, {id: string;data: PatchedReferralProgramRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  crmReferralProgramPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CrmReferralProgramPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>>
    export type CrmReferralProgramPartialUpdateMutationBody = PatchedReferralProgramRequest
    export type CrmReferralProgramPartialUpdateMutationError = unknown

    export const useCrmReferralProgramPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>, TError,{id: string;data: PatchedReferralProgramRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof crmReferralProgramPartialUpdate>>,
        TError,
        {id: string;data: PatchedReferralProgramRequest},
        TContext
      > => {

      const mutationOptions = getCrmReferralProgramPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type crmReferralsListResponse200 = {
  data: PaginatedReferralList
  status: 200
}
    
export type crmReferralsListResponseSuccess = (crmReferralsListResponse200) & {
  headers: Headers;
};
;

export type crmReferralsListResponse = (crmReferralsListResponseSuccess)

export const getCrmReferralsListUrl = (params?: CrmReferralsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/crm/referrals/?${stringifiedParams}` : `/api/v1/crm/referrals/`
}

export const crmReferralsList = async (params?: CrmReferralsListParams, options?: RequestInit): Promise<crmReferralsListResponse> => {
  
  return apiFetch<crmReferralsListResponse>(getCrmReferralsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmReferralsListQueryKey = (params?: CrmReferralsListParams,) => {
    return [
    `/api/v1/crm/referrals/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCrmReferralsListQueryOptions = <TData = Awaited<ReturnType<typeof crmReferralsList>>, TError = unknown>(params?: CrmReferralsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmReferralsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmReferralsList>>> = ({ signal }) => crmReferralsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmReferralsListQueryResult = NonNullable<Awaited<ReturnType<typeof crmReferralsList>>>
export type CrmReferralsListQueryError = unknown


export function useCrmReferralsList<TData = Awaited<ReturnType<typeof crmReferralsList>>, TError = unknown>(
 params: undefined |  CrmReferralsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralsList>>,
          TError,
          Awaited<ReturnType<typeof crmReferralsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralsList<TData = Awaited<ReturnType<typeof crmReferralsList>>, TError = unknown>(
 params?: CrmReferralsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralsList>>,
          TError,
          Awaited<ReturnType<typeof crmReferralsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralsList<TData = Awaited<ReturnType<typeof crmReferralsList>>, TError = unknown>(
 params?: CrmReferralsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmReferralsList<TData = Awaited<ReturnType<typeof crmReferralsList>>, TError = unknown>(
 params?: CrmReferralsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmReferralsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type crmReferralsRetrieveResponse200 = {
  data: Referral
  status: 200
}
    
export type crmReferralsRetrieveResponseSuccess = (crmReferralsRetrieveResponse200) & {
  headers: Headers;
};
;

export type crmReferralsRetrieveResponse = (crmReferralsRetrieveResponseSuccess)

export const getCrmReferralsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/crm/referrals/${id}/`
}

export const crmReferralsRetrieve = async (id: string, options?: RequestInit): Promise<crmReferralsRetrieveResponse> => {
  
  return apiFetch<crmReferralsRetrieveResponse>(getCrmReferralsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCrmReferralsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/crm/referrals/${id}/`
    ] as const;
    }

    
export const getCrmReferralsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCrmReferralsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof crmReferralsRetrieve>>> = ({ signal }) => crmReferralsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CrmReferralsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof crmReferralsRetrieve>>>
export type CrmReferralsRetrieveQueryError = unknown


export function useCrmReferralsRetrieve<TData = Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmReferralsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralsRetrieve<TData = Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof crmReferralsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof crmReferralsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCrmReferralsRetrieve<TData = Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCrmReferralsRetrieve<TData = Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof crmReferralsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCrmReferralsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




